import request from '@/utils/request'


// 查询用户积分余额列表
export function listScore(query) {
  return request({
    url: '/user/score/list',
    method: 'get',
    params: query
  })
}

// 查询用户积分余额分页
export function pageScore(query) {
  return request({
    url: '/user/score/page',
    method: 'get',
    params: query
  })
}

// 查询用户积分余额详细
export function getScore(data) {
  return request({
    url: '/user/score/detail',
    method: 'get',
    params: data
  })
}

// 新增用户积分余额
export function addScore(data) {
  return request({
    url: '/user/score/add',
    method: 'post',
    data: data
  })
}

// 修改用户积分余额
export function updateScore(data) {
  return request({
    url: '/user/score/edit',
    method: 'post',
    data: data
  })
}

// 删除用户积分余额
export function delScore(data) {
  return request({
    url: '/user/score/delete',
    method: 'post',
    data: data
  })
}
